export default __webpack_public_path__ + "static/media/six.73da20cf.jpeg";